import { put } from 'redux-saga/effects';
import LoginAPI from "../services/loginApi";
import { endpoints } from '../services/endpoints';
import triggerAPI from '../services/triggerApi';
import {
    REPORT_SEND_RESPONSE, REPORT_SEND_FAILURE, BITALY_LINK_RESPONSE, BITALY_LINK_FAILURE
} from '../redux/types/reports';

let api = new LoginAPI();
let call = new triggerAPI();

export function* ReportSend({ payload, resolve }) {

    try {
        let { data } = yield call.triggerAPI(payload, endpoints.reports.reportSend);
        if (data?.success) {
            yield put({ type: REPORT_SEND_RESPONSE, payload: data })
            resolve && resolve(data)
        }
        else {
            resolve && resolve(data)
            yield put({ type: REPORT_SEND_FAILURE, payload: data })
        }
    } catch (e) {
        yield put({ type: REPORT_SEND_FAILURE, payload: "Something went wrong" })
    }
}

export function* Bitaly_link({ payload, resolve }) {
    let responsePayload = {};
    try {
        let { data } = yield api.Bitaly_Link(payload);
        responsePayload = data;
        if (data?.success) {
            yield put({ type: BITALY_LINK_RESPONSE, payload: responsePayload, })
            resolve && resolve(data)
        } else {
            yield put({ type: BITALY_LINK_FAILURE, payload: responsePayload })
            resolve && resolve(data)
        }
    } catch (e) {
        yield put({ type: BITALY_LINK_FAILURE, payload: responsePayload })
        resolve && resolve(responsePayload)

    }
}
